import { Component, EventEmitter, Input, Output } from '@angular/core';

import { GenericValue, HisNotificationService, HisBaseGlobalsService, HisUiService } from 'hisng';

import { ResearchInfrastructureUsage } from 'app/fs/res/research-infrastructure/model/research-infrastructure-classes';

@Component( {
    selector: 'res-research-infrastructure-edit-usage-numbers-dialog',
    templateUrl: './research-infrastructure-edit-usage-numbers-dialog.component.html',
} )
export class ResearchInfrastructureEditUsageNumbersDialogComponent {
    @Input() researchInfrastructureUsage: ResearchInfrastructureUsage;
    @Input() researchInfrastructureUsageType: GenericValue;
    @Input() i18nKey: string;
    @Input() hisDdKey: string;
    @Input() visibility = false;
    @Output() visibilityChange: EventEmitter<boolean> = new EventEmitter();
    @Output() researchInfrastructureUsageChange: EventEmitter<ResearchInfrastructureUsage> = new EventEmitter();

    public relevantUsages: ResearchInfrastructureUsage[] = [];

    constructor( private hisUiService: HisUiService,
        private notificationService: HisNotificationService,
        private hisBaseGlobalsService: HisBaseGlobalsService ) { }


    /* --------- Dialog action ----------- */

    public applyChanges() {
        this.notificationService.clear();

        let messages = this.getValidationMessages();
        if ( messages.length !== 0 ) {
            this.notificationService.error(
                messages,
                this.hisUiService.translate('global.validationerror')
            );
        } else {
            this.researchInfrastructureUsage.researchInfrastructureUsageType = this.researchInfrastructureUsageType;
            this.researchInfrastructureUsageChange.emit(this.researchInfrastructureUsage);
            this.closeDialog();
        }
    }

    /* close dialog action */
    public closeDialog() {
        this.visibilityChange.emit(false);
    }

    private getValidationMessages() {
        let messages = [];
        let inputRequired = this.hisUiService.translate('validation.required');
        let ddKeyRequiredUsageYear =
            this.hisBaseGlobalsService.getDd('fs.res.researchInfrastructure.ResearchInfrastructureUsage.usageYear');
        let ddKeyRequiredUsageAmount = this.hisBaseGlobalsService.getDd(this.hisDdKey + 'Amount');

        if ( !this.researchInfrastructureUsage.usageYear ) {
            if ( ddKeyRequiredUsageYear && ddKeyRequiredUsageYear.required ) {
                messages.push(`${this.hisUiService.translate(ddKeyRequiredUsageYear.identifier)}: ${inputRequired}`);
            }
        } else if ( this.researchInfrastructureUsage.usageYear > new Date().getFullYear() ) {
            messages.push(`${this.hisUiService.translate('fs.res.researchInfrastructure.ResearchInfrastructure.usageYear.FUTURE')}`);
        }
        if ( !this.researchInfrastructureUsage.usageAmount && ddKeyRequiredUsageAmount.required ) {
            messages.push(`${this.hisUiService.translate(ddKeyRequiredUsageAmount.identifier)}: ${inputRequired}`);
        }
        return messages;
    }
}
